import { observer } from "mobx-react-lite";

import { usePlayground } from "@/components/Playground/playground-store";
import { Chat } from "@/components/Playground/Drawer/Chat";
import Evaluate from "@/components/Playground/Drawer/Evaluate";
import Outputs from "@/components/Playground/Drawer/Outputs";
import { TOUR_LOCK_SCROLL_PROPS } from "@/components/Playground/tour/constants";
import { PLAYGROUND_DRAWER_MODES, PLAYGROUND_SESSION_MODES } from "@/components/Playground/types";

const ActiveInputSetChat = observer(() => {
  const { activeInputVariableSetId, input_variable_sets } = usePlayground();
  const activeInputSetIndex = input_variable_sets.findIndex(
    inputSet => inputSet.id === activeInputVariableSetId,
  );

  return <Chat variableSetIndex={Math.max(activeInputSetIndex, 0)} />;
});

const DrawerContent = () => {
  const { drawerMode, isChat, sessionMode } = usePlayground();
  const isEvaluateDrawer = drawerMode === PLAYGROUND_DRAWER_MODES.EVALUATE;
  const isChatSessionDrawer = isChat && sessionMode === PLAYGROUND_SESSION_MODES.CHAT;

  let drawerContent = isEvaluateDrawer ? <Evaluate /> : <Outputs />;
  if (isChatSessionDrawer) {
    drawerContent = <ActiveInputSetChat />;
  }

  return (
    <div className="relative h-full w-full">
      <div className="flex h-full w-full flex-col overflow-y-hidden scroll-smooth">
        <div className="relative h-full flex-1 overflow-y-auto" {...TOUR_LOCK_SCROLL_PROPS}>
          <div
            className="absolute flex h-full w-full flex-1 flex-col gap-y-2 overflow-y-auto"
            {...TOUR_LOCK_SCROLL_PROPS}
          >
            {drawerContent}
          </div>
        </div>
      </div>
    </div>
  );
};

export default observer(DrawerContent);
